import { Stack } from "@biggeo/bg-ui/lab";
import { CropFreeOutline, LayersOutline } from "@biggeo/bg-ui/lab/icons";
import isEmpty from "lodash/isEmpty";

import { FeedbackChip } from "../../../common/components/FeedbackChip";
import { useMap } from "../../mapbox/context";
import { DataGridDivider } from "../components/DatasetTableHeader";
import { IMapTopbar } from "../views/MapTopbar";
import { MapContextPolygonSource } from "../../mapbox/context/types";
import isEqual from "lodash/isEqual";
import uniqWith from "lodash/uniqWith";
import { useSavedBoundaries } from "../../mapbox/context/hooks";

const MapFeedbackContainer = ({
    deletePolygon,
    setNavTab,
}: Pick<IMapTopbar, "deletePolygon" | "setNavTab">) => {
    const { polygons } = useMap();

    const shapes = polygons.filter(
        (p) => p.source === MapContextPolygonSource.drawnShape
    );
    const boundaries = uniqWith(
        polygons.filter((p) => p.source === MapContextPolygonSource.boundary),
        (a, b) => isEqual(a.id, b.id)
    );

    const hasShapesApplied = !isEmpty(shapes);
    const hasBoundariesApplied = !isEmpty(boundaries);

    return (
        <Stack
            width="100%"
            height="100%"
            flexDirection="row"
            alignItems="center"
            gap={2}
            sx={{
                paddingLeft: 2,
            }}
        >
            {hasShapesApplied && (
                <Stack flexDirection="row" alignItems="center" gap={2}>
                    <DataGridDivider />
                    <FeedbackChip
                        startNode={<LayersOutline size="xs" />}
                        text="Shapes Applied"
                        onModalSaveClick={() => {
                            shapes.map((feature) => {
                                deletePolygon(feature.id);
                            });
                        }}
                        count={shapes.length || 0}
                        onClick={() => setNavTab("shapeLayers")}
                        subtitle="Proceeding will delete all shapes applied, are you sure you want to proceed?"
                        buttons={{
                            text1: "Keep Shapes",
                            text2: "Yes, Delete Shapes",
                        }}
                    />
                </Stack>
            )}
            {hasBoundariesApplied && (
                <Stack flexDirection="row" alignItems="center" gap={2}>
                    <DataGridDivider />
                    <FeedbackChip
                        startNode={<CropFreeOutline size="xs" />}
                        text="Boundaries Applied"
                        onModalSaveClick={() => {
                            boundaries.map((feature) => {
                                deletePolygon(feature.id);
                            });
                        }}
                        count={boundaries.length || 0}
                        onClick={() => setNavTab("boundaries")}
                        subtitle="Proceeding will delete all boundaries applied, are you sure you want to proceed?"
                        buttons={{
                            text1: "Keep Boundaries",
                            text2: "Yes, Delete Boundaries",
                        }}
                    />
                </Stack>
            )}
        </Stack>
    );
};

export default MapFeedbackContainer;
